import React,{Component} from 'react';
import {Button} from 'react-materialize';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
class StartPage extends Component{
    render(){
        return (
            <div>
                <div id="index-banner" >
                    <div>
                        <div>
                            <br/>

                            <div align="center">
                                <h5><FormattedMessage id={"quiz"} defaultMessage={"Teste seus conhecimentos na saúde ocupacional na aquicultura com 10 questões. Cada questão vale 10 pontos."}/></h5>
                            </div>
                            <br/>
                            <div align="center">
                                <Button waves='light' classname={"btn"} onClick={()=>this.props.handleState('running')}><FormattedMessage id={"btnComeçar"} defaultMessage={"Começar"}/></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StartPage;